import { useEffect, useState } from "react";
import {
  DownOutlined,
  FolderOutlined,
  FileOutlined,
  EditOutlined,
  DeleteOutlined,
  PlusOutlined,
  ShareAltOutlined,
  CopyOutlined,
} from "@ant-design/icons";
import { Tree, Button } from "antd";
import CustomButton from "../CommonComponents/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import CustomDialogBox from "../CommonComponents/CustomDialogBox";
import {
  Dialog,
  DialogContent,
  TableContainer,
  Typography,
  Paper,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";
import CustomCancelButton from "../CommonComponents/CustomCancelButton";
import CustomLabel from "../CommonComponents/CustomLabel";
import CustomTextField from "../CommonComponents/CustomTextField";
import CustomDropDown from "../CommonComponents/CustomDropDown";
import CustomActionButton from "../CommonComponents/CustomActionButton";
import CustomRadioButton from "../CommonComponents/CustomRadioButton";
import {
  addStandardTemplates,
  addTemplateGroup,
  addTemplateSubgroup,
  cloneTemplate,
  deleteTemplate,
  deleteTemplateGroup,
  editTemplateGroup,
  getTemplateGroups,
  getTemplateGroupTree,
} from "../../Restclient/datacollection";
import CustomToast from "../CommonComponents/CustomToast";
import { setSelectedTab, setTemplateState } from "../../store/cofig_data";
import CustomTreeSelect from "../CommonComponents/CustomTreeSelect";
import CustomTooltip from "../CommonComponents/CustomTooltip";

export default function TemplateGroup() {
  const dispatch = useDispatch();
  const theme = useSelector((state) => state.themedata.theme);
  const projectId = useSelector(
    (state) => state.mainpagedata.selectedprojectname,
  );
  const userdetails = useSelector((state) => state.logindata.userdetails);

  var code = "0";
  if (userdetails?.User_Role_Details?.Name == "EA_ADMIN") {
    code = "1";
  }

  const [update, setUpdate] = useState(0);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const handleClose = () => {
    setDeleteOpen(false);
  };

  const restCallbackDelete = (res) => {
    setDeleteOpen(false);
    setUpdate(res.data);
  };

  const handleDeleteConfirm = () => {
    setDeleteOpen(false);
    if (selectedType === "group") {
      deleteTemplateGroup(selectedKey, code, restCallbackDelete);
    } else if (selectedType === "template") {
      deleteTemplate(selectedKey, selectedTemplate, code, restCallbackDelete);
    }
  };

  const [selectedKey, setSelectedKey] = useState(null);
  const [selectedType, setSelectedType] = useState(null);

  const restCallbackAddSubgroup = (res) => {
    setOpenDialog(false);
    setUpdate(res.data);
  };

  const restCallbackEditGroup = (res) => {
    setOpenDialog(false);
    setUpdate(res.data);
  };

  const restCallbackGroupTree = (res) => {
    setGroupTree(res.data);
  };

  const [groupData, setGroupData] = useState([]);
  const restCallbackGroups = (res) => {
    setGroupData(processTreeData(res.data));
  };
  useEffect(() => {
    getTemplateGroups(code, restCallbackGroups);
    getTemplateGroupTree(code, restCallbackGroupTree);
  }, [update, projectId]);

  const [groupName, setGroupName] = useState("");
  const handleGroupName = (value) => {
    setGroupName(value);
  };

  const [selectedUser, setSelectedUser] = useState("");
  const handleUserChange = (value) => {
    setSelectedUser(value);
  };

  const [state, setState] = useState(0); //0 - Add root node, 1 - Edit any node, 2 - Add child node
  const [openDialog, setOpenDialog] = useState(false);
  const [accsessDialog, setAccessDialog] = useState(false);
  const [accessState, setAccessState] = useState(0);
  const [cloneDialog, setCloneDialog] = useState(false);
  const [templateCloneName, setTemplateCloneName] = useState("");
  const [selectedGroupVal, setSelectedGroupVal] = useState("");
  const [groupTree, setGroupTree] = useState([]);

  const restSaveGroupCallback = (res) => {
    setOpenDialog(false);
    setGroupName("");
    setUpdate(res.data);
  };
  const handleSaveGroup = () => {
    if (groupName === "") {
      return;
    }
    if (state === 0) {
      addTemplateGroup(groupName, code, restSaveGroupCallback);
    } else if (state === 1) {
      editTemplateGroup(selectedKey, groupName, code, restCallbackEditGroup);
    } else if (state === 2) {
      addTemplateSubgroup(
        selectedKey,
        groupName,
        code,
        restCallbackAddSubgroup,
      );
    } else {
      return;
    }
  };

  // Inline CSS
  const styles = `
    .ant-tree-treenode {
      width: 100%;
    }

    .ant-tree-node-content-wrapper {
      width: 100%;
      display: flex;
      align-items: center;
    }

    .node-actions {
      opacity: 0;
      transition: opacity 0.2s ease-in-out;
    }

    .ant-tree-node-content-wrapper:hover .node-actions {
      opacity: 1;
    }
  `;

  // Helper function to get nesting level from key
  const getLevel = (key) => {
    return key.split("/").length - 1;
  };

  // Helper function to check if node has children
  const hasChildren = (node) => {
    return node.children && node.children.length > 0;
  };

  // Helper to create node titles with right-aligned icons
  const renderTitle = (title, type, key, node) => {
    const level = getLevel(key);
    const canAddChild = level < 3; // Only levels 0 and 1 (level 1 and 2 in UI terms)
    const canDelete = !(
      hasChildren(node) ||
      title.startsWith("sg-") ||
      title.startsWith("st-")
    );

    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
        }}
      >
        {/* Left side: icon + title */}
        <div style={{ display: "flex", alignItems: "center" }}>
          {type === "group" ? (
            <FolderOutlined style={{ marginRight: 8 }} />
          ) : (
            <FileOutlined style={{ marginRight: 8 }} />
          )}
          <span style={{ fontSize: "14px", fontFamily: "Roboto" }}>
            {title}
          </span>
        </div>

        {/* Right side: action icons */}
        <div
          className="node-actions"
          style={{
            display: "flex",
            gap: 8,
            marginRight: 16,
            marginLeft: "36px",
          }}
        >
          <CustomTooltip
            title={"Edit"}
            offset={[30, -20]}
            placement={"right-end"}
          >
            <EditOutlined
              style={{
                color:
                  title.startsWith("sg-") || title.startsWith("st-")
                    ? "#d9d9d9"
                    : "#008cd7",
                cursor:
                  title.startsWith("sg-") || title.startsWith("st-")
                    ? "not-allowed"
                    : "pointer",
                opacity:
                  title.startsWith("sg-") || title.startsWith("st-") ? 0.5 : 1,
              }}
              onClick={(e) => {
                if (title.startsWith("sg-") || title.startsWith("st-")) {
                  return;
                }
                if (type === "group") {
                  setState(1);
                  setGroupName(title);
                  setSelectedKey(key);
                  setSelectedType(type);
                  setOpenDialog(true);
                } else if (type === "template") {
                  dispatch(
                    setTemplateState({
                      state: 2,
                      id: node.templateId,
                      name: key.split("/").slice(0, -1).join("/"),
                    }),
                  );
                  dispatch(setSelectedTab({ tab: "Template", value: 1 }));
                }
              }}
            />
          </CustomTooltip>
          <CustomTooltip
            title={"Subgroup"}
            offset={[30, -20]}
            placement={"right-end"}
          >
            {type === "group" && canAddChild && (
              <PlusOutlined
                style={{
                  color:
                    title.startsWith("sg-") || title.startsWith("st-")
                      ? "#d9d9d9"
                      : "#008cd7",
                  cursor:
                    title.startsWith("sg-") || title.startsWith("st-")
                      ? "not-allowed"
                      : "pointer",
                  opacity:
                    title.startsWith("sg-") || title.startsWith("st-")
                      ? 0.5
                      : 1,
                }}
                onClick={(e) => {
                  if (title.startsWith("sg-") || title.startsWith("st-")) {
                    return;
                  }
                  setState(2);
                  setOpenDialog(true);
                  setSelectedKey(key);
                  setSelectedType(type);
                }}
              />
            )}
          </CustomTooltip>
          <CustomTooltip
            title={"Clone"}
            offset={[30, -20]}
            placement={"right-end"}
          >
            {type === "template" && (
              <CopyOutlined
                style={{
                  color: "#008cd7",
                  cursor: "pointer",
                  opacity: 1,
                }}
                onClick={(e) => {
                  // setState(2);
                  setCloneDialog(true);
                  setSelectedKey(key);
                  setSelectedType(type);
                  if (type === "template") {
                    setSelectedTemplate(node.templateId);
                  }
                }}
              />
            )}
          </CustomTooltip>
          <CustomTooltip
            title={"Delete"}
            offset={[30, -20]}
            placement={"right-end"}
          >
            <DeleteOutlined
              style={{
                color: canDelete ? "#008cd7" : "#d9d9d9",
                cursor: canDelete ? "pointer" : "not-allowed",
                opacity: canDelete ? 1 : 0.5,
              }}
              onClick={(e) => {
                e.stopPropagation();
                if (canDelete) {
                  setDeleteOpen(true);
                  setSelectedKey(key);
                  setSelectedType(type);
                  if (type === "template") {
                    setSelectedTemplate(node.templateId);
                  }
                } else {
                  return;
                }
              }}
            />
          </CustomTooltip>
          <CustomTooltip
            title={"Template"}
            offset={[30, -20]}
            placement={"right-end"}
          >
            {type === "group" && (
              <FileOutlined
                style={{
                  color:
                    title.startsWith("sg-") || title.startsWith("st-")
                      ? "#d9d9d9"
                      : "#008cd7",
                  cursor:
                    title.startsWith("sg-") || title.startsWith("st-")
                      ? "not-allowed"
                      : "pointer",
                  opacity:
                    title.startsWith("sg-") || title.startsWith("st-")
                      ? 0.5
                      : 1,
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  if (title.startsWith("sg-") || title.startsWith("st-")) {
                    return;
                  }
                  dispatch(
                    setTemplateState({ state: 1, id: key, name: title }),
                  );
                  dispatch(setSelectedTab({ tab: "Template", value: 1 }));
                }}
              />
            )}
          </CustomTooltip>
        </div>
      </div>
    );
  };

  // Helper to process tree data and add renderTitle with node context
  const processTreeData = (nodes) => {
    return nodes.map((node) => {
      const processedNode = {
        ...node,
        title: renderTitle(node.title || node.key, node.type, node.key, node),
        children: node.children ? processTreeData(node.children) : undefined,
      };
      return processedNode;
    });
  };

  // Tree structure (with plain titles, will be processed)
  const rawTreeData = [
    {
      title: "EnergyTemplates",
      key: "0-0",
      type: "group",
      children: [],
    },
  ];

  const treeData = processTreeData(rawTreeData);

  const onSelect = (selectedKeys, info) => {
    return;
  };

  const handleClone = () => {
    cloneTemplate(selectedKey, templateCloneName, selectedGroupVal, (res) => {
      setCloneDialog(false);
      setTemplateCloneName("");
      setSelectedGroupVal(null);
      setUpdate(res.data);
    });
  };

  return (
    <div
      style={{ height: "100%", width: "100%", boxSizing: "border-box" }}
      className="compliance-config"
    >
      {update === 1 && (
        <CustomToast
          openToast={1}
          type={"Success"}
          autoHideDuration={10000}
          toastText={"Group Added Successfully!"}
          onClose={() => setUpdate(0)}
        />
      )}
      {update === -1 && (
        <CustomToast
          openToast={1}
          type={"Error"}
          autoHideDuration={10000}
          toastText={"Error in Adding Group!"}
          onClose={() => setUpdate(0)}
        />
      )}
      {update === 2 && (
        <CustomToast
          openToast={1}
          type={"Success"}
          autoHideDuration={10000}
          toastText={"Subgroup Added Successfully!"}
          onClose={() => setUpdate(0)}
        />
      )}
      {update === -2 && (
        <CustomToast
          openToast={1}
          type={"Error"}
          autoHideDuration={10000}
          toastText={"Error in Adding Subroup!"}
          onClose={() => setUpdate(0)}
        />
      )}
      {update === 3 && (
        <CustomToast
          openToast={1}
          type={"Success"}
          autoHideDuration={10000}
          toastText={"Group Edited Successfully!"}
          onClose={() => setUpdate(0)}
        />
      )}
      {update === -3 && (
        <CustomToast
          openToast={1}
          type={"Error"}
          autoHideDuration={10000}
          toastText={"Error in Editing Group!"}
          onClose={() => setUpdate(0)}
        />
      )}
      {update === 4 && (
        <CustomToast
          openToast={1}
          type={"Success"}
          autoHideDuration={10000}
          toastText={"Group Deleted Successfully!"}
          onClose={() => setUpdate(0)}
        />
      )}
      {update === -4 && (
        <CustomToast
          openToast={1}
          type={"Error"}
          autoHideDuration={10000}
          toastText={"Error in Deleting Group!"}
          onClose={() => setUpdate(0)}
        />
      )}
      {update === -5 && (
        <CustomToast
          openToast={1}
          type={"Error"}
          autoHideDuration={10000}
          toastText={"Group already exists!"}
          onClose={() => setUpdate(0)}
        />
      )}
      {update === -6 && (
        <CustomToast
          openToast={1}
          type={"Error"}
          autoHideDuration={10000}
          toastText={"Duplicate subgroup at the same level!"}
          onClose={() => setUpdate(0)}
        />
      )}
      {update === 7 && (
        <CustomToast
          openToast={1}
          type={"Success"}
          autoHideDuration={10000}
          toastText={"Template Deleted Successfully!"}
          onClose={() => setUpdate(0)}
        />
      )}
      {update === -7 && (
        <CustomToast
          openToast={1}
          type={"Error"}
          autoHideDuration={10000}
          toastText={"Error in Deleting Template!"}
          onClose={() => setUpdate(0)}
        />
      )}
      {update === 8 && (
        <CustomToast
          openToast={1}
          type={"Success"}
          autoHideDuration={10000}
          toastText={"Standard Templates Updated Successfully!"}
          onClose={() => setUpdate(0)}
        />
      )}
      {update === -8 && (
        <CustomToast
          openToast={1}
          type={"Error"}
          autoHideDuration={10000}
          toastText={"Error in Updating Standard Templates!"}
          onClose={() => setUpdate(0)}
        />
      )}
      {update === 9 && (
        <CustomToast
          openToast={1}
          type={"Success"}
          autoHideDuration={10000}
          toastText={"Template Cloned Successfully!"}
          onClose={() => setUpdate(0)}
        />
      )}
      {update === -9 && (
        <CustomToast
          openToast={1}
          type={"Error"}
          autoHideDuration={10000}
          toastText={"Error in Cloning Template!"}
          onClose={() => setUpdate(0)}
        />
      )}
      {update === -10 && (
        <CustomToast
          openToast={1}
          type={"Error"}
          autoHideDuration={10000}
          toastText={"Template Name Already Exists!"}
          onClose={() => setUpdate(0)}
        />
      )}
      {/* Inject CSS */}
      <style>{styles}</style>

      <table
        style={{
          textAlign: "left",
          padding: "0px",
          margin: "0px",
          marginBottom: "16px",
          width: "100%",
        }}
      >
        <tbody>
          <tr>
            <td
              style={{
                textAlign: "right",
                width: "5%",
              }}
            >
              <CustomButton
                buttonText={"Add Group"}
                onClick={() => {
                  setState(0);
                  setOpenDialog(true);
                }}
              />
              {/* {code === "0" && (
                <>
                  <span style={{ paddingLeft: "8px" }}></span>
                  <CustomButton
                    buttonText={"Add Standard Templates"}
                    onClick={() => {
                      addStandardTemplates((res) => {
                        setUpdate(res.data);
                      });
                    }}
                  />
                </>
              )} */}
            </td>
          </tr>
        </tbody>
      </table>
      {groupData.length > 0 ? (
        <Tree
          style={{
            backgroundColor: "var(--SecondaryBackground)",
            color: "var(--PrimaryText)",
          }}
          showLine
          defaultExpandAll
          switcherIcon={<DownOutlined />}
          onSelect={onSelect}
          treeData={groupData}
        />
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "200px",
            backgroundColor: "var(--SecondaryBackground)",
            color: "var(--SecondaryText)",
            fontSize: "14px",
            fontFamily: "Roboto",
          }}
        >
          No data available
        </div>
      )}
      {
        <CustomDialogBox
          openDialog={deleteOpen}
          dialogTitle={"Delete"}
          dialogText={"Are you sure?"}
          confirmText={"Delete"}
          cancelText={"Cancel"}
          handleCloseDialog={handleClose}
          handleConfirmDialog={handleDeleteConfirm}
          type={"Info"}
        />
      }
      {
        <Dialog
          maxWidth={"xl"}
          open={openDialog}
          aria-labelledby="responsive-dialog-title"
          PaperProps={{
            style: {
              backgroundColor: theme === "dark" ? "#000000" : "#EFEFEF",
              boxShadow: "none",
              borderRadius: "0px",
              width: "500px",
              height: "150px",
            },
          }}
          BackdropProps={{
            style: {
              backgroundColor:
                theme === "dark" ? "rgba(255,255,255,0.7)" : "rgba(0,0,0,0.7)",
            },
          }}
        >
          <DialogContent>
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: "10px",
                  gap: "8px",
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{
                    color: theme === "dark" ? "#FFFFFF" : "#5B5B5B",
                    fontSize: "16px",
                    fontWeight: 700,
                  }}
                >
                  {state === 0
                    ? "Add Template Group"
                    : state === 1
                      ? "Edit Template Group"
                      : "Add Template Subgroup"}
                </Typography>
                <div style={{ flexGrow: 1 }}> </div>

                <CustomButton buttonText={"Save"} onClick={handleSaveGroup} />
                <CustomCancelButton
                  buttonText={"Cancel"}
                  onClick={() => {
                    setOpenDialog(false);
                    setGroupName("");
                  }}
                />
              </div>
              <div
                style={{
                  height: "calc(100% - 48px)",
                  width: "100%",
                  backgroundColor: theme === "light" ? "#ffffff" : "#1e1e1e",
                }}
              >
                <table>
                  <tr>
                    <td style={{ padding: "16px", paddingRight: "16px" }}>
                      <CustomLabel
                        labelText={"Template Group*"}
                        htmlFor={"template-group"}
                        color={"var(--SecondaryText)"}
                        paddingTop={6}
                      />
                    </td>
                    <td>
                      <CustomTextField
                        id={"new-template-name"}
                        width={270}
                        onChange={handleGroupName}
                        defaultValue={state === 0 ? "" : groupName}
                        permittedCharacters={"^[a-zA-Z0-9_]*$"}
                      />
                    </td>
                  </tr>
                </table>
              </div>
            </>
          </DialogContent>
        </Dialog>
      }
      {
        <Dialog
          maxWidth={"xl"}
          open={cloneDialog}
          aria-labelledby="responsive-dialog-title"
          PaperProps={{
            style: {
              backgroundColor: theme === "dark" ? "#000000" : "#EFEFEF",
              boxShadow: "none",
              borderRadius: "0px",
              width: "500px",
              height: "220px",
            },
          }}
          BackdropProps={{
            style: {
              backgroundColor:
                theme === "dark" ? "rgba(255,255,255,0.7)" : "rgba(0,0,0,0.7)",
            },
          }}
        >
          <DialogContent>
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: "10px",
                  gap: "8px",
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{
                    color: theme === "dark" ? "#FFFFFF" : "#5B5B5B",
                    fontSize: "16px",
                    fontWeight: 700,
                  }}
                >
                  Clone Template
                </Typography>
                <div style={{ flexGrow: 1 }}> </div>

                <CustomButton buttonText={"Save"} onClick={handleClone} />
                <CustomCancelButton
                  buttonText={"Cancel"}
                  onClick={() => {
                    setCloneDialog(false);
                    setTemplateCloneName("");
                    setSelectedGroupVal(null);
                  }}
                />
              </div>
              <div
                style={{
                  height: "calc(100% - 48px)",
                  width: "100%",
                  backgroundColor: theme === "light" ? "#ffffff" : "#1e1e1e",
                }}
              >
                <table>
                  <tr>
                    <td style={{ padding: "16px", paddingRight: "16px" }}>
                      <CustomLabel
                        labelText={"Template Group*"}
                        htmlFor={"template-group"}
                        color={"var(--SecondaryText)"}
                        paddingTop={6}
                      />
                    </td>
                    <td>
                      <CustomTreeSelect
                        options={groupTree}
                        value={selectedGroupVal}
                        defaultValue={selectedGroupVal}
                        onChange={(val) => setSelectedGroupVal(val)}
                        placeholder=""
                        width="270px"
                        fontSize="16px"
                        disabledItemValues={(item) =>
                          item.title.startsWith("sg-")
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td style={{ padding: "16px", paddingRight: "16px" }}>
                      <CustomLabel
                        labelText={"Template Name*"}
                        htmlFor={"template-name"}
                        color={"var(--SecondaryText)"}
                        paddingTop={6}
                      />
                    </td>
                    <td>
                      <CustomTextField
                        id={"new-template-name"}
                        width={270}
                        onChange={(val) => setTemplateCloneName(val)}
                        permittedCharacters={"^[a-zA-Z0-9_]*$"}
                      />
                    </td>
                  </tr>
                </table>
              </div>
            </>
          </DialogContent>
        </Dialog>
      }

      {
        <Dialog
          maxWidth={"xl"}
          open={accsessDialog}
          aria-labelledby="responsive-dialog-title"
          PaperProps={{
            style: {
              backgroundColor: theme === "dark" ? "#000000" : "#EFEFEF",
              boxShadow: "none",
              borderRadius: "0px",
              width: "500px",
              height: "300px",
            },
          }}
          BackdropProps={{
            style: {
              backgroundColor:
                theme === "dark" ? "rgba(255,255,255,0.7)" : "rgba(0,0,0,0.7)",
            },
          }}
        >
          <DialogContent>
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: "10px",
                  gap: "8px",
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{
                    color: theme === "dark" ? "#FFFFFF" : "#5B5B5B",
                    fontSize: "16px",
                    fontWeight: 700,
                  }}
                >
                  {accessState === 0 ? "Manage Access" : "Access Summary"}
                </Typography>
                <div style={{ flexGrow: 1 }}> </div>

                <CustomButton
                  buttonText={"Save"}
                  onClick={() => {
                    setAccessDialog(false);
                  }}
                />
                {accessState === 0 ? (
                  <CustomCancelButton
                    buttonText={"Cancel"}
                    onClick={() => setAccessDialog(false)}
                  />
                ) : (
                  <CustomCancelButton
                    buttonText={"Back"}
                    onClick={() => setAccessState(0)}
                  />
                )}
              </div>
              <div
                style={{
                  height: "calc(100% - 48px)",
                  width: "100%",
                  backgroundColor: theme === "light" ? "#ffffff" : "#1e1e1e",
                }}
              >
                {accessState === 0 && (
                  <>
                    <table>
                      <tr>
                        <td style={{ padding: "16px", paddingRight: "16px" }}>
                          <CustomLabel
                            labelText={"Select Users"}
                            htmlFor={"template-group"}
                            color={"var(--SecondaryText)"}
                            paddingTop={6}
                          />
                        </td>
                        <td>
                          <CustomDropDown
                            options={["User1", "User2", "User3"]}
                            onChange={handleUserChange}
                            width={300}
                            name={"generate-list"}
                            defaultValue={null}
                          />
                        </td>
                      </tr>
                    </table>

                    <TableContainer
                      component={Paper}
                      sx={{
                        width: "calc(100% - 16px)",
                        height: "62%",
                        paddingLeft: "8px",
                        backgroundColor: "var(--secondary-backgroundLK)",
                        paddingRight: "8px",
                      }}
                      elevation={0}
                    >
                      <Table stickyHeader sx={{ width: "100%" }} size="small">
                        <TableBody>
                          {[
                            ["User1", "Owner"],
                            ["User2", "Can Edit"],
                            ["User3", "Can Edit"],
                            ["User4", "Can Edit"],
                            ["User5", "Can Edit"],
                            ["User6", "Can Edit"],
                            ["User7", "Can Edit"],
                            ["User8", "Can Edit"],
                            ["User9", "Can Edit"],
                            ["User10", "Can Edit"],
                            ["User11", "Can Edit"],
                            ["User12", "Can Edit"],
                          ].map((row, rowIndex) => (
                            <TableRow
                              key={rowIndex}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                                height: "9px",
                                "& > *": {
                                  borderBottom:
                                    "1px solid var(--table-boarder-line)",
                                },
                              }}
                            >
                              {row.map((cell, cellIndex) => {
                                if (cellIndex === 0) {
                                  return (
                                    <TableCell
                                      key={cellIndex}
                                      component="th"
                                      scope="row"
                                      sx={{
                                        fontSize: "12px",
                                        fontWeight: 400,
                                        color:
                                          "var(--grey-variation-tablerowsLK)",
                                      }}
                                    >
                                      {cell}
                                    </TableCell>
                                  );
                                } else {
                                  return (
                                    <TableCell
                                      key={cellIndex}
                                      component="th"
                                      scope="row"
                                      sx={{
                                        fontSize: "12px",
                                        fontWeight: 400,
                                        color:
                                          "var(--grey-variation-tablerowsLK)",
                                      }}
                                    >
                                      <CustomActionButton
                                        buttonText={cell}
                                        disabled={
                                          cell === "Owner" ? true : false
                                        }
                                        onClick={() => {
                                          setAccessState(1);
                                        }}
                                      />
                                    </TableCell>
                                  );
                                }
                              })}
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </>
                )}
                {accessState === 1 && (
                  <div style={{ padding: "16px" }}>
                    <table>
                      <tr>
                        <td
                          style={{
                            padding: "16px",
                            paddingRight: "16px",
                            paddingBottom: "0px",
                          }}
                        >
                          <CustomLabel
                            labelText={"User2 "}
                            htmlFor={"template-group"}
                            color={"var(--SecondaryText)"}
                            paddingTop={6}
                          />
                        </td>
                        <td
                          style={{
                            padding: "16px",
                            paddingRight: "16px",
                            paddingBottom: "0px",
                          }}
                        >
                          <CustomLabel
                            labelText={"Can Edit"}
                            htmlFor={"template-group"}
                            color={"var(--SecondaryText)"}
                            paddingTop={6}
                            fontWeight={700}
                          />
                        </td>
                      </tr>
                    </table>
                    <hr />

                    <CustomRadioButton
                      options={[
                        ["Can View", "Can View"],
                        ["Can Edit", "Can Edit"],
                        ["No Access", "No Access"],
                      ]}
                      defaultValue={"Can Edit"}
                      fontSize={16}
                    />
                  </div>
                )}
              </div>
            </>
          </DialogContent>
        </Dialog>
      }
    </div>
  );
}
